import React from "react";
import { Card, Table, Icon, Divider, Button, Form, message } from 'antd';

import NHFetch from "../../../../utils/NHFetch";
import { getLoginUser } from "../../../../utils/NHCore";
import { NHConfirm } from '../../../common/NHModal';
import PropTypes from "prop-types";

const hjdm = "GD002_2";   //环节代码
const basicUrl = "/yxxc/";
const jfxtBasicUrl = 'api/zhxg-jfxt/';


class JfblFb extends React.Component {
    constructor() {
        super()
        this.state = {
            editable: true,
            basicdata: [],
            studentData: {},
            loading: false,
            jffaData: {},       //缴费方案信息
            jccsData: {},      //基础参数信息
            djcsData: {},     //缴费对接参数信息
            xsxxData: {},     //学生信息
            jfblzt:true,       //从第三方获取改环节是否可以办理，true表示可办理，fasle表示不可办理
        }
    }
 
    componentWillReceiveProps(nextProps) { 
        if ('studentData' in nextProps) {
            const studentData = nextProps.studentData;

            //查询到学生信息时才显示绿色通道环节办理业务项
            if (Object.keys(studentData).length != 0) {
                //查询到不同学生
                if (JSON.stringify(this.state.studentData) === '{}' || this.state.studentData !== studentData) {
                    this.setState({ studentData: studentData }); 
                    this.queryPayPlan();
                } 
               
                this.setState({ show: true });

            } else {
                this.setState({ show: false });
            }
        }

        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (hjblztData) {
                let editable = hjblztData.blzt == '1' ? false : true;
                this.setState({ hjblztData: hjblztData, editable: editable });
            } else {
                this.setState({ hjblztData: hjblztData, editable: true });
            }
        }

    }


      //根据环节代码获取对应的缴费方案数据
      queryPayPlan =()=>{ 
        NHFetch('api/zhxg-yxwz/jfxt/queryPayPlan','GET',{hjdm:hjdm}).then(res =>{
            if(res && res.data){
                this.setState({
                    jffaData: res.data['jffaVO'],
                    jccsData:res.data['jfdjJccsVO']
                },()=>{  
                    this.checkDataSource();
                    this.queryPayParams()
                })
            }else {
                message.error("该环节未设置缴费方案")
            }
        })
    }

    //校验数据来源
    checkDataSource =() =>{
        const { jfqkly } = this.state.jccsData; 
        if (jfqkly == '0'){//0:中间库，1：第三方接口
            this.queryPayListByDataBaseForXc();
        } else if (jfqkly == '1') {
            this.queryPayInfoList();
        }
    }

       //中间库
       queryPayListByDataBaseForXc = () => {
        const { xsid, sfzjh, xh } = this.props.studentData;
        NHFetch('api/zhxg-yxwz/jfxt/queryPayListByDataBaseForXc', 'GET', {xsid:xsid, sfzjh:sfzjh, xh:xh})//所有的收费数据
            .then(resData => {
                if (resData && resData.data) {
                    // 获取缴费数据，根据已有的规则判断是否符合自动办理
                    // 财务欠费公式：(应收billAmount - 减免derateAmount - 实收（累计）payedAmount + 退款（累计）refundAmount) > 0；
                    // 业务欠费公式：(应收billAmount - 减免derateAmount - 实收（累计）payedAmount - 缓交postponeAmount + 退款（累计）refundAmount) > 0。
                    // 学生每一项缴费项目，只要是达到财务欠费结果或者业务欠费结果=0，就说明学生没有欠费，自动办理缴费环节
                    let jfxxList = resData.data;
                    if(jfxxList.length > 0){
                        NHFetch('api/zhxg-yxwz/openapi/yxxt/getBlztByXsidForXc', 'GET', {xsid:xsid, sfzjh:sfzjh, xh:xh}).then(resData => {
                            if (resData && resData.data) {
                                if(resData.data.BLZT == '1') {
                                    this.checkIsZzbdHjLinked(); //使用自动办理会导致不能点击取消按钮无效，点击取消按钮刷新后自动办理
                                    this.setState({ jfblzt: resData.data.BLZT=='1'?true:false  } );
                                    
                                }
                            }
                        });
                    }
                    this.setState({ basicdata: resData.data } );
                }
            });
    }

    //第三方接口
    queryPayInfoList =()=>{ 
        const { xsid } = this.props.studentData;
        NHFetch('api/zhxg-yxwz/jfxt/yxxcQueryPayInfoList','GET',{hjdm:hjdm,xsid:xsid}).then(res =>{
            if (res && res.data['sfxxList']){
                if (res.data['sfbl']){
                    this.setState({ jfblzt: res.data['sfbl']  } );
                    this.checkIsZzbdHjLinked();  //使用自动办理会导致不能点击取消按钮无效，点击取消按钮刷新后自动办理
                } 
                
                this.setState({ basicdata: res.data['sfxxList'] } );
                console.log("接口学生缴费信息：",res.data['sfxxList'] )
            }else { 
                message.info("查询不到学生的缴费信息，请联系管理员处理")
            }
        })
    }

        //查询缴费对接参数
        queryPayParams =() =>{
            const { djfsid } = this.state.jffaData;
            NHFetch('api/zhxg-yxwz/jfxt/queryPayParams','GET',{djfsid:djfsid}).then(res =>{
                if (res && res.data){
                    this.setState({
                        djcsData:res.data,
                    })
                }else {
                    message.error("获取缴费对接参数失败")
                }
            })
        }

    //检查该环节是否已经办理,未办理则自动办理
    checkIsZzbdHjLinked = () => { 
        if(this.state.hjblztData.blzt != '1'){
            this.handleSubmit();
        } 
    };


    handleSubmit = () => {
        const { pkid } = this.state.hjblztData;
        const { jfblzt } = this.state.jfblzt;
        const { xsid } = this.props.studentData;
        
        if(jfblzt ==false || jfblzt =='false'){
            message.error("学生未缴完费，不可办理该环节！");
            return;
        }

        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }

        let userId = getLoginUser() ? getLoginUser().userId : '';
        let params = { xsid: xsid, lchjid: pkid, yhbh: userId, hjdm: hjdm };
        this.setState({ loading: true });
        NHFetch(basicUrl + 'saveCustomLinkData', 'POST', params)
            .then(res => {
                if (res) {
                    if (res.data == '1') {
                        message.success('环节办理成功！');
                        //办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish('submit');
                        }
                        this.setState({ loading: false });
                    } else {
                        message.error('环节办理失败，请重试！');
                        this.setState({ loading: false });
                    }
                }
                this.setState({ loading: false });
            }).catch((ress) => {
                this.setState({ loading: false });
            })
    };

    handleCancel = () => {
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.state.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : ''; 
        let params = { xsid: xsid, hjdm: hjdm, yhbh: userId,  lchjid: pkid };

        NHConfirm("是否确定取消办理？", () => {
            this.setState({ loading: true });
            NHFetch(basicUrl + 'cancelCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('环节办理取消成功！');
                            //取消办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('cancel');
                            }
                            this.setState({ loading: false });
                        } else {
                            message.error('环节办理取消失败，请重试！');
                            this.setState({ loading: false });
                        }
                    }
                    this.setState({ loading: false });
                }).catch((ress) => {
                    this.setState({ loading: false });
                })
        }, "warn");
    }

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }


    render() {
        const { editable, loading } = this.state;
        const { lchjData = {}, hasLast, hasNext } = this.props;

        const { sfdybdd = '0' } = lchjData; //是否打印报到单

        const columns = [
            // {
            //     name: '收费项目',
            //     dataIndex: 'name',
            //     key: 'name',
            // }, {
            //     title: '应缴金额（元）',
            //     dataIndex: 'yjje',
            //     key: 'yjje',
            // }, {
            //     title: '已缴金额（元）',
            //     dataIndex: 'yjnje',
            //     key: 'yjnje',
            // }, {
            //     title: '是否缴清',
            //     dataIndex: 'sfjq',
            //     key: 'sfjq',
            //     render: (text, record) => (
            //         record.yjje - record.yjnje == 0 ? <span><Icon type="check-circle" style={{ color: '#4BC819' }} /> <a
            //             href="javascript:;">已缴清</a></span> :
            //             record.yjje - record.yjnje > 0 && record.id == 'total' ?
            //                 <span style={{ color: '#ff0000' }}> 欠费 {record.yjje - record.yjnje} 元</span> :
            //                 <span style={{ color: '#ff0000' }}><Icon type="exclamation-circle"
            //                     style={{ color: '#FAAE13' }} /> 欠费</span>
            //     )
            // }
            {
                title: '收费项目',
                dataIndex: 'sfxmmc',
            },
            {
                title: '应收金额（元）',
                dataIndex: 'ysje',
            },
            {
                title: '实收金额（元）',
                dataIndex: 'ssje',
                render: (text, record) => {
                    return <span>{text}</span>;
                }
            },
            {
                title: '减免金额（元）',
                dataIndex: 'jmje',
                render: (text, record) => {
                    return <span>{text}</span>;
                }
            },
            {
                title: '缓交金额（元）',
                dataIndex: 'hjje',
                render: (text, record) => {
                    return <span>{record.hjje ? record.hjje : '0'}</span>;
                }
            },
            {
                title: '欠费金额（元）',
                dataIndex: 'qfje',
                render: (text, record) => {
                    if (text > 0) {
                        return <span className="text-info-red">{text}</span>
                    } else {
                        return text
                    }
                }
            }
        ];

        let data = [];

        const basicdata = this.state.basicdata;
        console.log("接口学生缴费信息basicdata：",basicdata )
        // const basicdata = [
        if (basicdata.length) {
            let yjje = 0;
            let yjnje = 0; 
            let jmje = 0;
            let hjje = 0;
            let qfje = 0;
            basicdata.forEach((item) => {
                yjje += Number(item.ysje);
                yjnje += Number(item.ssje);
                jmje += Number(item.jmje);
                hjje += Number(item.hjje);
                qfje += Number(item.qfje);
            });
            data = basicdata.concat({
                sfxmmc: '合计',
                ysje: yjje,
                ssje: yjnje,
                jmje: jmje,
                hjje: hjje,
                qfje: qfje
            });
        }


        return (
            <div>
                <Card type="inner" title="缴费办理业务信息">
                    <Table
                        style={{ marginBottom: 24 }}
                        pagination={false}
                        dataSource={data}
                        columns={columns}
                        rowKey="id"
                    />
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                {editable ? <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button> :
                    <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button>
                }
                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast ?
                        <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button>
                        : null
                }
                {
                    hasNext ?
                        <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button>
                        : null
                }
            </div>
        )
    }
}


JfblFb.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态信息
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一步
    hasNext: PropTypes.bool, //是否有下一步
    onLast: PropTypes.func, //上一步事件回调
    onNext: PropTypes.func, //下一步事件回调
    onFinish: PropTypes.func, //确认办理、取消办理完成回调
    onPrint: PropTypes.func, //打印报到单
}
const jfblFb = Form.create()(JfblFb);
export default JfblFb;


// WEBPACK FOOTER //
// ./components/yxxc/steps/jfbl/jfblFb.js